// extracted by mini-css-extract-plugin
export default {"banner":"X3idB","banner__headline":"HbX7Q","banner__description_btn_wrapper":"HroQm","banner__description":"B530r","banner__button":"IEpl_"};